import { useState } from 'react';

import isEqual from 'lodash/isEqual';

import { set } from './utils';

export interface FiltersValues {
  [field: string]: any;
}

export interface FiltersConfig {
  initialValues: FiltersValues;
  defaultValues?: FiltersValues;
}

export const useFilters = ({
  initialValues,
  defaultValues = {},
}: FiltersConfig) => {
  const [values, setValues] = useState(initialValues);
  const setFieldValue = (name: string, value: any) => {
    setValues(prevValues => set(prevValues, name, value));
  };

  const resetFilters = () => setValues(defaultValues);

  const canResetFilters = !isEqual(values, defaultValues);

  return {
    values,
    setFieldValue,
    resetFilters,
    canResetFilters,
  };
};
